(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("serverRendered_script_bundle", [], factory);
	else if(typeof exports === 'object')
		exports["serverRendered_script_bundle"] = factory();
	else
		root["serverRendered_script_bundle"] = factory();
})(this, function() {
return 